<template>
  <div class="homecontainer">
    <div class="titleAndCarousel">
      <el-row>
        <!-- <el-col :span="12"><yiyoBackground /></el-col>
        <el-col :span="12"><picCarousel :picList="picList"/></el-col> -->
        <el-col :sm="24" :md="12"><yiyoBackground /></el-col>
        <el-col :sm="24" :md="12"><picCarousel :picList="picList"/></el-col>
      </el-row>
    </div>
    <div class="introContainer" style="margin-top:57px;padding-top:220px;padding-bottom:150px; background: #F8F8F8;">
      <!-- <div class="firstIntro">
        <div class="introText">
          <span class="valueProp">VALUE PROP</span>
          <span class="introTitle">如同纸张扫描的原稿处理</span>
          <span class="introContent">直接打开Office和HTML文件进行原稿处理、翻译和译审，提供锁定、图片文字处理、OLE文件处理等细致的原稿处理功能，可让用户完整地翻译文件中的所有内容。</span>
          <span class="learnmorn">Learn more</span>
        </div>
        <div class="introPic"></div>
      </div>
      <div class="secondIntro">
        <div class="introPic"></div>
        <div class="introText" style="padding-left:140px;"> 
          <span class="valueProp">VALUE PROP</span>
          <span class="introTitle">强大的搜索引擎和记忆库</span>
          <span class="introContent">轻松地应对千万级的大型记忆库，可以让翻译组织内的所有成员共享所有项目的记忆库。</span>
          <span class="learnmorn">Learn more</span>
        </div>
      </div>
      <div class="thirdIntro">
        <div class="introText">
          <span class="valueProp">VALUE PROP</span>
          <span class="introTitle">个人任务，社群网络，及翻译供应链</span>
          <span class="introContent">用户可以为一项翻译工作编制任务计划，自动流转，实时监控；制定个人日程，与协同工作伙伴共享；加入社群或创建群组甚至是供应链，实现资源共享。</span>
          <span class="learnmorn">Learn more</span>
        </div>
        <div class="introPic"></div>
      </div> -->
      <!-- <el-row>
        <el-col :sm="24" :md="12" class="left-el-col">
          <div class="introText">
            <span class="introTitle">聊天下/全球聊</span>
            <span class="introContent">轻松搭讪外国人。您会发现这个地球上没有人是您无法沟通的。</span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12" class="right-el-col">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="left-el-col">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12" class="right-el-col">
          <div class="introText">
            <span class="introTitle">搜天下/全球搜</span>
            <span class="introContent">
              您可用母语关键词，搜遍全球的外语网站，您可看到翻译成母语的搜索结果。
              <p>例如：您在关键词处输入中文"语言教育"，搜索语言选择为"日语"，您就可以看到日本语言教育相关的网站。而且已被翻译成中文。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">用母语写外文</span>
            <span class="introContent">如果您的外语半生不熟或者一窍不通，请一定去试试如何用母语来写外文，一定会给您带来意想不到的乐趣。</span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">Ai小蜜蜂</span>
            <span class="introContent">
              在AI翻译引擎领域，即使最强如谷歌，但在不同语种、不同专业领域，也经常输给其他的翻译引擎。翻译引擎不仅取决于算法，还取决于训练算法的语料是否精良。
              <p>玫瑰虽美，百草园更加绚烂多彩，在AI技术百花齐放的今天，AI小蜜蜂专门为您采集百草之精华，以您所用的语言而定制AI翻译。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">所见即所得</span>
            <span class="introContent">如果你也讨厌CAT软件把一篇完整的文章打碎成一串离散的句子，让它们失去语境。请一定要试试全文翻译是什么体验。</span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">格式编辑和非译词汇</span>
            <span class="introContent">
              再见了，Tag编辑！
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">强大的记忆库搜索引擎</span>
            <span class="introContent">轻松挑战千万条级大型记忆库</span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">句型库</span>
            <span class="introContent">
              在翻译时，术语和句型非常重要，但CAT软件中只有术语管理而无句型管理。
              <p>我们提供给您一种方法，可以像管理术语一样管理句型。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">网络词典的引用</span>
            <span class="introContent">可以把网络词典像内建词典一样引入到CAT软件内使用。真的吗？
              <p>但需要您配合跟随自定义步骤，走完一个查阅词典的流程，教会软件如何查阅词典，之后软件就可以帮您自动去查词典了。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">协同翻译</span>
            <span class="introContent">
              大型项目需要多人协同翻译时，协同工作的软件之间可实时交互，保证能获得最新的术语、句型和记忆库。
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">PDF文件转换</span>
            <span class="introContent">您可以将PDF转化为Office进行翻译。</span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">自定义语言</span>
            <span class="introContent">
              如果您想把甲骨文或者女书翻译成现代汉语怎么办？自定义甲骨文或女书为一种新语言即可使用本软件的除翻译记忆库之外的所有功能。全球几千种稀有语种，都可以自由定义。这是专为保护稀有语种和古籍的研究者设计的功能。
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">译前处理</span>
            <span class="introContent">word原稿中Excel怎么办？插图中有文字？红色高亮部分不想翻译怎么办？ </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">译前分析和译后分析</span>
            <span class="introContent">
              翻译不是以千字单位计算的吗？但如果您使用了翻译记忆库和翻译引擎后还用千字单位计算吗？翻译记忆库和翻译引擎可大大提高翻译效率。那该如何进行计算更加合理呢？
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">好友与好友聊天</span>
            <span class="introContent">与外国译者交流，用Email和skype吧？效率有点低。
              <p>试试译友聊天吧，您不仅可以用母语直接聊，还可以把聊天内容记忆到任务内，随时可以查阅该任务与译者聊了啥。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">工作日历</span>
            <span class="introContent">
              想给译者安排翻译，却不知道译者能不能接工作。如果您想给一个生活在地球另一边讲外语译者安排工作时就更麻烦了。
              <p>工作日历的周期模式可让译者5分钟就安排好一年的计划。译者当前的繁忙度也会反映到工作日历中，还可以自由切换以本地时间和译者当地时间显示日历。译者的工作日历一目了然。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">任务分派</span>
            <span class="introContent">翻译项目管理工作中最令人头疼的是不是任务分配，经常排到深夜还是无法找到合适的译者？
              <p>如果有抢单、自动轮询、指派三种分配任务的模式可供您自由使用，会不会觉得很爽。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">任务控制</span>
            <span class="introContent">
              如果突然发现任务需要紧急暂停或被取消该怎样处理？对于有保密义务的工作，需要定时清除译者侧的文件时怎么处理？任务实施过程中可能会发生许多紧急情况，您可以尝试任务控制功能。
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">任务监测与报警</span>
            <span class="introContent">译者的翻译进程会被实时传送给项目管理者，如果有延误，会以黄色报警和红色报警提醒管理者。如果此时您想查看译者的最新文件，单键即可获取。
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">任务间自动流转</span>
            <span class="introContent">
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">任务转发</span>
            <span class="introContent">顾名思义，就是把从客户那里收到的任务重新规划往下发给译者、译审者或供应商。
              <p>转发，是建立跨企业协同工作的核心，可对整条翻译供应链进行任务分发、控制和管理。项目管理者都可向下监控整条供应链的实时进程，并可单键获得最新的文件，无论供应链有多深。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">记忆库的质量管理</span>
            <span class="introContent">
              翻译记忆库的来源可能复杂多样，其中可能包含未经审查的译文，也可能包含初学者的译文，也可能存在误译。面对来源不可信的记忆库我们无法通过大海捞针来审查几百万条的记忆库挑出不可信的译文。要么冒险使用，要么只能弃用。
              <p>真的吗？</p>
              <p>记忆库的质量也是可以管理的，一套完整的记忆库质量管理方法可以帮您轻松地搞定这个问题。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24" :md="12" class="">
          <div class="introText">
            <span class="introTitle">翻译标准</span>
            <span class="introContent" style="font-size: 20px;">为了管理翻译工作的质量，您是不是有过要制定翻译标准的冲动。
              <p>实际上各国翻译界也都在努力，中国有中国国标，日本有日本翻译协会翻译标准，欧洲有欧洲标准。可是您在工作中遇见过翻译标准吗？他们长什么样子？没有吧。</p>
              <p>为什么翻译标准会被翻译界束之高阁呢？不是翻译标准不好，而是缺少一个让翻译标准落地的工具。译友开发了一个可让各国翻译标准简单落地的模型和工具。</p>
              <p>您都有耐心看完翻译标准了，何不去下载试试，我们是一个非常专业非常敬业的团队，一定不会让您后悔的。</p>
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row v-for="item in introTextList">
        <el-col :sm="24" :md="12">
          <div class="introText">
            <span class="introTitle">{{item.introTitle}}</span>
            <span class="introContent">{{item.introContent}}
            
            </span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </el-col>
        <el-col :sm="24" :md="12">
          <div class="introPic">
            <img class="introContent" v-if="isImag" />
            <vedio class="introContent" v-else />
            <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
          </div>
        </el-col>
      </el-row> -->

      
      
      <div class="introSecContainer" v-for="item in introTextList">
        <div style="display: table" :class="{rightClass:item.class=='rightCol', leftClass:item.class=='leftCol'}">
          <div class="introText">
            <span class="introTitle">{{item.introTitle}}</span>
            <span class="introContent">{{item.introContent}}</span>
            <a :href="fileUrl" download="YIYO.exe" target="_blank" class="learnmorn">试试吧，免费的</a>
          </div>
        </div>
        <div class="introPic">
          <video v-if="item.isVideo" class="introVideo" autoplay playsinline muted loop :src="item.introImage" type="video/mp4"></video>
          <img v-else :src="item.introImage" :alt="$t('messages.top_img')">
        </div>
        <el-button :plain="true" @click.native="getStart()" class="splitBtn">试试吧，免费的</el-button>
      </div>

      <el-button :plain="true" @click.native="getStart()" >Get Started — for free</el-button>
    </div>
    <div class="solutionContainer">
      <p>Stakeholder Solutions</p>
      <div class="solutionContent">
        <el-row>
          <el-col :sm="24" :md="8">
            <div class="solutionTranslator">
              <span class="solutionPic">
                <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
              </span>
              <span class="solutionTitle">Individual Translators</span>
            </div>
          </el-col>
          <el-col :sm="24" :md="8">
            <div class="solutionTeams">
              <span class="solutionPic">
                <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
              </span>
              <span class="solutionTitle">Project Teams</span>
            </div>
          </el-col>
          <el-col :sm="24" :md="8">
            <div class="solutionCompanies">
              <span class="solutionPic">
                <img src="../assets/images/Desert.jpg" :alt="$t('messages.top_img')">
              </span>
              <span class="solutionTitle">Companies</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <a :href="fileUrl" download="YIYO.msi" target="_blank"><el-button :plain="true" >Get Started — for free</el-button></a> -->
      <el-button :plain="true" @click.native="getStart()">Get Started — for free</el-button>
    </div>
     
  </div>
</template>

<script>
import yiyoBackground from '@/components/YiyoBackground'
import picCarousel from '@/components/PicCarousel'
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
      picList:[
        require('../assets/images/Desert.jpg'),
        require('../assets/images/Jellyfish.jpg'),
        require('../assets/images/Lighthouse.jpg'),
      ],
      fileUrl:'https://yiyo-static-new.oss-cn-hangzhou.aliyuncs.com/setup.msi',
      // conten1:' :class="{leftClass:item.class=='leftCol'}" ',
      introTextList:[
        {
          introTitle: '跨国聊',
          introContent: '轻松搭讪外国人。您会发现这个地球上没有人是您无法沟通的。',
          introImage: require('../assets/images/GlobalChat.png'),
          isVideo: false,
          class:'leftCol',
        },
        {
          introTitle: '全球搜',
          introContent: '您可用母语关键词，搜遍全球的外语网站，你可看到翻译成母语的搜索结果。',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'rightCol'
        },
        {
          introTitle: '用母语写外文',
          introContent: '如果您的外语半生不熟或者一窍不通，请一定去试试如何用母语来写外文，一定会给您带来意想不到的乐趣。',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: 'Ai小蜜蜂',
          introContent: '在AI翻译引擎领域，即使最强如谷歌，但在不同语种、不同专业领域，也经常输给其他的翻译引擎。翻译引擎不仅取决于算法，还取决于训练算法的语料是否精良。 \n 玫瑰虽美，百草园更加绚烂多彩，在AI技术百花齐放的今天，AI小蜜蜂专门为您采集百草之精华，以您所用的语言而定制AI翻译。',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'rightCol'
        },
        {
          introTitle: '所见即所得',
          introContent: '如果你也讨厌CAT软件把一篇完整的文章打碎成一串离散的句子，让它们失去语境。请一定要试试全文翻译是什么体验。',
          introImage: require('../assets/images/WhatYouSeeIs WhatYouGet.png'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '格式编辑和非译词汇',
          introContent: '再见了，Tag编辑！',
          introImage: require('../assets/video/FormatEditor.mp4'),
          isVideo: true,
          class:'rightCol'
        },
        {
          introTitle: '强大的记忆库搜索引擎',
          introContent: '轻松挑战千万条级大型记忆库',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '句型库',
          introContent: '在翻译时，术语和句型非常重要，但CAT软件中只有术语管理而无句型管理。 \n 我们提供给您一种方法，可以像管理术语一样管理句型。',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'rightCol'
        },
        {
          introTitle: '网络词典的引用',
          introContent: '可以把网络词典像内建词典一样引入到CAT软件内使用。真的吗？\n但需要您配合跟随自定义步骤，走完一个查阅词典的流程，教会软件如何查阅词典，之后软件就可以帮您自动去查词典了',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '协同翻译',
          introContent: '大型项目需要多人协同翻译时，协同工作的软件之间可实时交互，保证能获得最新的术语、句型和记忆库。',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'rightCol'
        },
        {
          introTitle: 'PDF文件转换',
          introContent: '您可以将PDF转化为Office进行翻译。',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '自定义语言',
          introContent: '如果您想把甲骨文或者女书翻译成现代汉语怎么办？自定义甲骨文或女书为一种新语言即可使用本软件的除翻译记忆库之外的所有功能。全球几千种稀有语种，都可以自由定义。这是专为保护稀有语种和古籍的研究者设计的功能。',
          introImage: require('../assets/video/CustomLanguage.mp4'),
          isVideo: true,
          class:'rightCol'
        },
        {
          introTitle: '译前处理',
          introContent: 'word原稿中Excel怎么办？插图中有文字？红色高亮部分不想翻译怎么办？',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '译前分析和译后分析',
          introContent: '翻译不是以千字单位计算的吗？但如果您使用了翻译记忆库和翻译引擎后还用千字单位计算吗？翻译记忆库和翻译引擎可大大提高翻译效率。那该如何进行计算更加合理呢？',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'rightCol'
        },
        {
          introTitle: '工作日历',
          introContent: '想给译者安排翻译，却不知道译者能不能接工作。如果您想给一个生活在地球另一边讲外语译者安排工作时就更麻烦了。\n工作日历的周期模式可让译者5分钟就安排好一年的计划。译者当前的繁忙度也会反映到工作日历中，还可以自由切换以本地时间和译者当地时间显示日历。译者的工作日历一目了然。',
          introImage: require('../assets/images/ShopCalendar.png'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '任务分派',
          introContent: '翻译项目管理工作中最令人头疼的是不是任务分配，经常排到深夜还是无法找到合适的译者？\n如果有抢单、自动轮询、指派三种分配任务的模式可供您自由使用，会不会觉得很爽。',
          introImage: require('../assets/video/TaskAssignment.mp4'),
          isVideo: true,
          class:'rightCol'
        },
        {
          introTitle: '任务控制',
          introContent: '如果突然发现任务需要紧急暂停或被取消该怎样处理？对于有保密义务的工作，需要定时清除译者侧的文件时怎么处理？任务实施过程中可能会发生许多紧急情况，您可以尝试任务控制功能。',
          introImage: require('../assets/images/TaskControl.png'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '任务监测与报警',
          introContent: '译者的翻译进程会被实时传送给项目管理者，如果有延误，会以黄色报警和红色报警提醒管理者。如果此时您想查看译者的最新文件，单键即可获取。',
          introImage: require('../assets/images/TaskMonitoringAndAlerting.png'),
          isVideo: false,
          class:'rightCol'
        },
        {
          introTitle: '任务间自动流转',
          introContent: '项目管理者需要做的可能只是编制任务计划，翻译-->译审-->译审确认-->返回管理者，您可以用任务间自动流转功能，放手让计划自动实施，只用监测是否有报警，无报警就不予干预，等待最终结果回来就好了。',
          introImage: require('../assets/video/TaskForwarding.mp4'),
          isVideo: true,
          class:'leftCol'
        },
        {
          introTitle: '任务转发',
          introContent: '顾名思义，就是把从客户那里收到的任务重新规划往下发给译者、译审者或供应商。\n转发，是建立跨企业协同工作的核心，可对整条翻译供应链进行任务分发、控制和管理。项目管理者都可向下监控整条供应链的实时进程，并可单键获得最新的文件，无论供应链有多深。',
          introImage: require('../assets/video/TaskRotation.mp4'),
          isVideo: true,
          class:'rightCol'
        },
        {
          introTitle: '记忆库的质量管理',
          introContent: '翻译记忆库的来源可能复杂多样，其中可能包含未经审查的译文，也可能包含初学者的译文，也可能存在误译。面对来源不可信的记忆库我们无法通过大海捞针来审查几百万条的记忆库挑出不可信的译文。要么冒险使用，要么只能弃用。\n真的吗？\n记忆库的质量也是可以管理的，一套完整的记忆库质量管理方法可以帮您轻松地搞定这个问题。',
          introImage: require('../assets/images/Desert.jpg'),
          isVideo: false,
          class:'leftCol'
        },
        {
          introTitle: '翻译标准',
          introContent: '为了管理翻译工作的质量，您是不是有过要制定翻译标准的冲动。\n实际上各国翻译界也都在努力，中国有中国国标，日本有日本翻译协会翻译标准，欧洲有欧洲标准。可是您在工作中遇见过翻译标准吗？他们长什么样子？没有吧。\n为什么翻译标准会被翻译界束之高阁呢？不是翻译标准不好，而是缺少一个让翻译标准落地的工具。译友开发了一个可让各国翻译标准简单落地的模型和工具。\n您都有耐心看完翻译标准了，何不去下载试试，我们是一个非常专业非常敬业的团队，一定不会让您后悔的。',
          introImage: require('../assets/images/TranslationStandards.png'),
          isVideo: false,
          class:'rightCol'
        },
      ],
    }
  },
  mounted: function () {
    this.$nextTick(function () {

    })
  },
  computed: {
    
  },
  methods: {
    getUser(){
      this.salesmanUid = 1;
      this.$axios.get('/api/user').then(res=>{
          console.log(res)
      })
    },
    getStart(){
      const a = document.createElement('a');
        a.href = this.fileUrl;
        a.download = "setup";
        a.style.display="none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },
  },
  components:{
    yiyoBackground:yiyoBackground,
    picCarousel:picCarousel
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
html{
  font-size: 625%;
}
.homecontainer{
    padding: 0;
    margin-top:40px;
    padding-bottom:80px;
}
.rightClass{
  order: 3;
}
.splitBtn{
  display:none;
}
@media screen and (min-width: 1500px) {
  .homecontainer .introContainer .el-row .el-col{
    display: table-cell!important;
    vertical-align: middle!important;
  }
  .homecontainer .introText{
    width:655px!important;
    height:544px!important;
  }
  .homecontainer .introPic{
    width: 556px!important;
    height: 544px!important;
  }
  .homecontainer .solutionContainer{
    height:1038px!important;
  }
  .homecontainer .solutionContainer .solutionTranslator,.solutionTeams,.solutionCompanies{
    display:inline-block!important;
    width: 365px!important;
    height: 442px!important;
  }
  .el-row{
    width: 1300px;
    margin: 0 auto;
  }
}
@media screen and (max-width: 991px) {
  /*.homecontainer .introContainer .el-row .el-col{
    display: table-cell;
    vertical-align: middle;
  }*/
  .homecontainer .introText { 
    width:600px; 
    margin: 0 auto;
    align-items: center;
  }
  /*.homecontainer .introPic img{
    max-width: 100%;
    max-height: none!important;
    border-radius: 18px;
    object-fit: cover;
  }
  .homecontainer .introContainer .el-row{
    margin-bottom: 40px!important;
  }*/
}
@media screen and (max-width: 1010px){
  
  .homecontainer .introPic img{
    max-width: none!important;
    max-height: 100%!important;
  }
  .solutionPic img{
    max-width: none!important;
    max-height: 100%!important;
  }
  .homecontainer .introText{
    height: auto!important;
    padding-top: 40px!important;
  }
  .homecontainer .learnmorn{
    display: none!important;
  }

  /*设置文字在上，图片在下*/
  .rightClass{
    order: 3!important;
  }
  .leftClass{
    order: 5!important;
  }
  .splitBtn{ /*只有小屏幕时显示按钮，用作分隔线*/
    display: block!important;
    margin-top: 50px;
  }
  .homecontainer .introContainer .introSecContainer{
    flex-wrap: wrap;
    flex-direction: column-reverse;
    margin-bottom: 60px!important;
  }
  .homecontainer .solutionContainer .el-button {
    padding: 0 10px !important;
    max-width: 380px;
    width: 90% !important;
    font-size: 20px !important;
    white-space: pre-wrap;
  }
  .homecontainer .introContainer .el-button{
    padding: 0 10px !important;
    max-width: 380px;
    width: 90% !important;
    font-size: 20px !important;
    white-space: pre-wrap;
  }
} 

.homecontainer .introContainer .introSecContainer{
  width: 100%;
  max-width: 1300px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 140px;
}
.homecontainer .introText{
  /*width:655px;
  height:544px;
  display:inline-block;
  text-align:left;
  width: 100%;
  display: table-cell;
  vertical-align: middle;
  height:544px;
  text-align:left;
  padding: 0 8%;*/
  width: 100%;
  max-width:655px;
  max-height:544px;
  display: table-cell;
  vertical-align: middle;
  height:544px;
  text-align:left;
  padding: 0 8%;
  flex-grow: 1;
}
.homecontainer .introPic{
  position: relative;
  /*width: 556px;
  height: 544px;
  left: 0;
  top: 0;
  vertical-align:bottom;
  width:556px;
  background: #FFFFFF;
  border-radius: 18px;
  display: table-cell;
  vertical-align: middle;
  display: inline-block;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  width: 93%;
  height:544px;
  margin: 0 2%;
  overflow: hidden;
  text-align: center;*/
  display: inline-block;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  width: 93%;
  max-width: 556px;
  height:544px;
  margin: 0 3%;
  overflow: hidden;
  text-align: center;
  flex-grow: 1;
  order: 2;
}
.homecontainer .introVideo{
  width: 100%;
  height: auto;
  object-fit: cover;
}
.homecontainer .introPic img{
  width: auto;
  border-radius: 18px;
  object-fit: cover;
  max-height: 100%;
}
.homecontainer .introTitle{
  /*position: relative;
  width: 643px;
  height: 53px;
  top: 151px;
  display:block;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 53px;
  color: #000000;*/
  width: 100%;
  margin-bottom: 10px;
  display: inline-block;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 53px;
  color: #000000;
}
.homecontainer .introContent{
  /*position: relative;
  width: 516px;
  height: 142px;
  top:162px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 36px;
  color: #000000;
  display:block;*/
  width: 100%;
  margin-bottom: 50px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 36px;
  color: #000000;
  display: inline-block;
  white-space: pre-wrap;
}
.homecontainer .learnmorn{
  position: relative;
  height: 23px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-decoration-line: underline;
  color: #222222;
  display:block;
  /*
  top:191px;
  width: 106px;
  width: 45% !important;
  text-align: center!important;
  padding: 0px!important;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  display: inline-block;
  height: 63px;
  background: #222222;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  line-height: 27px;
  color:#ffffff;
  font-size: 22px;*/
}
.homecontainer .firstIntro{margin:0 auto;}
.homecontainer .secondIntro{margin:140px auto;}
.homecontainer .thirdIntro{margin:140px auto;}
.homecontainer .valueProp{
  position: relative;
  width: 150px;
  height: 27px;
  top: 144px;
  display:block;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  color: #AFAFAF;
}
.homecontainer .introContainer .el-button{
  align-items: center;
  padding: 18px 62px;
  width: 368px;
  height: 63px;
  background: #222222;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
  color:#ffffff;
}
.homecontainer .el-button:hover{
  opacity:0.9;
  border-color:#000;
}
.homecontainer .solutionContainer{
  /*top:140px;
  height:1038px;*/
  margin-top: 140px;
  height: auto;
  width: 100%;
}
.homecontainer .solutionContainer p{
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 46px;
  text-align: center;
  color: #000000;
}
.homecontainer .solutionContainer .solutionContent{margin:0 auto;margin-top:106px;}
.homecontainer .solutionContainer .solutionTranslator,.solutionTeams,.solutionCompanies{
  /*display:inline-block;
  width: 365px;
  height: 442px;
  background: #F8F8F8;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;*/
  margin-bottom: 50px;display:inline-block;
  width: 90%;
  max-width: 365px;
  height: 442px;
  background: #F8F8F8;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
}
/*.homecontainer .solutionContainer .solutionTeams,.solutionCompanies{margin-left:65px;}*/
.homecontainer .solutionContainer .solutionPic{
  height:332px;
  display:block;
  overflow: hidden;
  border-radius: 18px 18px 0px 0px;
}
.solutionPic img{
  width: auto;
  object-fit: cover;
  max-height: 100%;
  border-radius: 18px 18px 0px 0px;
}
.homecontainer .solutionContainer .solutionTitle{
  /*width: 365px;
  height: 110px;
  background: #FFFFFF;
  border-radius: 0px 0px 18px 18px;
  display:block;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 110px;
  text-align: center;
  color: #000000;*/
  width: 100%;
  height: 110px;
  background: #FFFFFF;
  border-radius: 0px 0px 18px 18px;
  display:block;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 110px;
  text-align: center;
  color: #000000;
}
.homecontainer .solutionContainer .el-button{
  align-items: center;
  padding: 18px 62px;
  width: 368px;
  height: 63px;
  background: #222222;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-weight: 500;
  font-size: 22px;
  line-height: 27px;
  color:#ffffff;
  margin-top:53px;
}
.homecontainer .titleAndCarousel{
  margin: 73px 50px 0px 20px;
}
.homecontainer .titleAndCarousel .el-row .el-col{
  padding: 0px 0px 10px 30px;
}
/* .homecontainer .introText{
  width:655px;
  height:544px;
  display:inline-block;
  text-align:left;


  width: 100%;
  display: table-cell;
  vertical-align: middle;
  height:544px;
  text-align:left;
  padding: 0 8%;
}
.homecontainer .introPic{
  position: relative;
  width: 556px;
  height: 544px;
  left: 0;
  top: 0;
  vertical-align:bottom;
  width:556px;
  background: #FFFFFF;
  border-radius: 18px;
  display: table-cell;
  vertical-align: middle;


  display: inline-block;
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 18px;
  width: 93%;
  height:544px;
  margin: 0 2%;
  overflow: hidden;
  text-align: center;
}
.homecontainer .introPic img{
  width: auto;
  border-radius: 18px;
  object-fit: cover;
  max-height: 100%;
}
.homecontainer .introContainer .el-row{
  margin-bottom: 140px;
}
.homecontainer .introTitle{
  position: relative;
  width: 643px;
  height: 53px;
  top: 151px;
  display:block;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 53px;
  color: #000000;


  width: 100%;
  margin-bottom: 10px;
  display: inline-block;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 38px;
  line-height: 53px;
  color: #000000;
}
.homecontainer .introContent{
  position: relative;
  width: 516px;
  height: 142px;
  top:162px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 36px;
  color: #000000;
  display:block;


  width: 100%;
  margin-bottom: 50px;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 300;
  font-size: 26px;
  line-height: 36px;
  color: #000000;
  display: inline-block;
  white-space: pre-wrap;
}
.homecontainer .learnmorn{
  position: relative;
  height: 23px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  text-decoration-line: underline;
  color: #222222;
  display:block;


  top:191px;
  width: 106px;
  width: 45% !important;
  text-align: center!important;
  padding: 0px!important;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  display: inline-block;
  height: 63px;
  background: #222222;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  line-height: 27px;
  color:#ffffff;
  font-size: 22px;
}*/
</style>




// WEBPACK FOOTER //
// src/components/Home.vue